<h4 mat-dialog-title class="qm-bg-light-gray">
  {{ data.Title }}
</h4>

<div mat-dialog-content>
  <p [innerHtml]="data.Message ? data.Message : 'Something wrong, please try again.'"></p>
</div>

<div mat-dialog-actions align="end">
  @if (data.NeedNoBtn) {
    <button mat-flat-button class="qm-dark-gray-theme" (click)="close(data.NoBtnValue)">
      {{ data.NoBtnName }}
    </button>
  }
  @if (data.NeedYesBtn) {
    <button mat-flat-button class="ms-3" (click)="close(data.YesBtnValue)">
      {{ data.YesBtnName }}
    </button>
  }
</div>
